/* eslint-disable import/prefer-default-export */
import moment from 'moment';
import * as RegExps from '../classification/RegExps';

/**
 * 対象が空文字、null、undefinedのいずれかの場合、trueを返します。
 * @param target 検査文字列
 */
export const isEmpty = (target: any) => target === '' || target === null || target === undefined;

/**
 * 数値をカンマ区切り文字列に変換します。
 *
 * @param target カンマ区切り対象
 */
export const separateNumber = (target: number) => String(target).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');

/**
 * 日時文字列を指定のフォーマット文字列に変換
 *  デフォルト 'YYYY/MM/DD(ddd) HH:mm'
 * @param date 日付文字列
 * @param format 日付フォーマット
 */
export const toJapanDateString = (date: string, format?: string) => {
  if (isEmpty(date)) return '';
  const formatStr = isEmpty(format) ? 'MM/DD/YYYY hh:mm A' : format;
  moment.locale('en');
  return moment(date).format(formatStr);
};

/**
 * 対象文字列をURLセーフなBase64にエンコード
 * @param str 変換対象文字列
 */
export const encodeToBase64Url = (str: string) => {
  const base64Str = Buffer.from(str).toString('base64');
  return base64Str.replace(/\+/g, '-').replace(/\//g, '_');
};

/**
 * URLセーフなBase64文字列をデコード
 * @param base64Str Base64文字列
 */
export const decodeFromBase64Url = (base64Str: string) => {
  const str = base64Str.replace(/-/g, '+').replace(/_/g, '/');
  return Buffer.from(str, 'base64').toString();
};


/**
 * 中国漢字が含まれているか判定する
 * 簡体字または繁体字かつ訓音の無い漢字の場合は中国漢字として判断する
 * @param str 判定文字列
 */
export const isIncludeChineseChar = (str: string) => (RegExps.REG_HANTAI.test(str) || RegExps.REG_KANTAI.test(str)) && !RegExps.REG_JP_HAN.test(str);

/**
 * 絵文字が含まれているか判定する
 * @param str 判定文字列
 */
export const isIncludeEmoji = (str: string) => RegExps.REG_EMOJI.test(str);

/**
 * 機種依存文字が含まれているか判定する
 * @param str 判定文字列
 */
export const isIncludeMachineDependentChar = (str: string) => RegExps.REG_MACHINE_DEPENDENT.test(str);

/**
 * 無効な文字が含まれているか判定する
 * @param str 判定文字列
 */
export const isIncludeInvalidChar = (str: string) => isIncludeChineseChar(str) || isIncludeEmoji(str) || isIncludeMachineDependentChar(str);
